module.exports = __webpack_public_path__ + "static/media/dq-conf-2022-img.916225ee.png";